<template>
  <router-view />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("operations");

/**
 * Operationの共通処理を行うコンポーネント
 */
export default {
  name: "OperationCommonSetup",
  methods: {
    ...mapActions(["resetOperationFeatureState"]),
  },

  async beforeDestroy() {
    this.$nextTick(async () => {
      //  operationの画面から離れる際に、storeをリセットする
      await Promise.allSettled([
        this.resetOperationFeatureState(), // マスタデータ・レポートのstoreをリセット
      ]);
    });
  },
};
</script>
